import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import getGeneric from "../../../actions/getGeneric"
import { parseFilters } from "../../Filters/utils/fetchData"
import { get } from "lodash"

const useFetchAiAnalyticsWidgetData = ({
    widgetId,
    appliedFilterValues,
    widget_config,
    skip,
    tempFilters = {},
    widgetIdPrefixForUniqueStoreMapping = "",
    data_tag = "DATATAG_DELIGHTIQ_GET_AGGREGATED_DATA",
    apiResponseKey = "APITAG_DELIGHTIQ_AGGREGATE_DATA"
}) => {

    const [data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const dataMetricType = "default"
    const dataCurrentLevel = "default"

    const dispatch = useDispatch()
    const dd = useSelector(e => e?.insightsReducer?.discovery)

    const fetchData = () => {
        if (skip) return
        // let data = (get(dd, `${widgetId}.chartData.${dataMetricType}.${dataCurrentLevel}`, null))
        // if (data) {
        //     setData(data)
        //     return
        // }
        const { filters, benchmark } = parseFilters(appliedFilterValues);
        setIsLoading(true)
        dispatch(getGeneric({
            requestBody: {
                data_tag,
                request_data: {
                    widget_id: widgetId,
                    filters,
                    benchmark,
                    widget_config,
                    ...tempFilters
                }
            },

            onSuccess: response => {
                setIsLoading(false)
                dispatch({
                    type: "SAVE_WIDGET_CHART_DATA",
                    payload: {
                        widgetId: widgetId + widgetIdPrefixForUniqueStoreMapping,
                        metricType: dataMetricType,
                        chartData: get(response, `api_response.${apiResponseKey}.data`, {}),
                        currentLevel: dataCurrentLevel
                    }
                })
                const data = get(response, `api_response.${apiResponseKey}.data`, {})
                setData(data)
            },
            onError: error => {
                setIsLoading(false)
            }
        }))
    }

    useEffect(() => {
        fetchData()
    }, [appliedFilterValues])


    return ({ data, fetchData, isLoading })
}
export default useFetchAiAnalyticsWidgetData